module.exports = __webpack_public_path__ + "img/hoimg2.2ed5574c.png";